export default {
    props: {
        dot: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        addCurrentDot() {
            if (!this.dot) {
                return;
            }
            const lastVal = this.chartData[this.chartData.length - 1];
            if (lastVal.v === null) {
                return;
            }
            this.gChart.append('circle')
                .attr('class', 'current-dot')
                .attr('cx', this.xScaleTime(lastVal.d))
                .attr('cy', this.yScaleLinear(lastVal.v))
                .attr('r', 3);
        },
        addValueDots() {
            const data = this.chartData;

            // add dots at each datapoint
            this.gChart.selectAll('circle.value-dot')
                .data(data)
                .enter()
                .append('circle')
                .attr('class', (d, i) => `value-dot value-dot-${i}`)
                .style('opacity', 0)
                .attr('cx', d => this.xScaleTime(d.d))
                .attr('cy', d => this.yScaleLinear(d.v))
                .attr('r', 5);
        },
        highlightDot(index) {
            this.gChart.selectAll('circle.value-dot')
            .style('opacity', (d, i) => {
                if (i === index) {
                    return 1;
                }
                return 0;
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/d3SparklineValueDots.js